import { render, staticRenderFns } from "./TemplateLinkClientsDialog.vue?vue&type=template&id=71e12fd7&scoped=true"
import script from "./TemplateLinkClientsDialog.vue?vue&type=script&lang=js"
export * from "./TemplateLinkClientsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e12fd7",
  null
  
)

export default component.exports